<template>

  <div>

    <div v-if="permissions.includes('manage_candidates')">

      <div
        v-if="!selectedJob"
        class="alert alert-warning">
        {{ $t('To add a task, select a job') }}
      </div>

      <div
        v-if="selectedJob"
        class="card">
        <div class="card-body">
          <CandidateTaskForm
            :initValue="{}"
            @created="createdTask" />
        </div>
      </div>
    </div>

    <CandidateFeed :activityType="'task'" />

  </div>

</template>

<script>
import CandidateTaskForm from './CandidateTaskForm'
import CandidateFeed from '../Feed/CandidateFeed'

export default {
  name: 'CandidateTask',
  components: {
    CandidateTaskForm,
    CandidateFeed
  },
  props: [
  ],
  data () {
    return {
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    selectedJob () {
      return this.$store.getters.getCandidateSelectedJob
    },
    candidate () {
      return this.$store.getters.getCandidate
    }
  },
  created () {
  },
  methods: {
    createdTask (task) {
      return this.$store
      .dispatch('refreshSelectActivities')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Candidate/Task/CandidateTask.vue